export const formatUsd = (n: number) =>
	n.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: n >= 1000 ? 0 : 2,
	});

export const formatNumber = (n: number) =>
	n.toLocaleString("en-US", { maximumFractionDigits: 2 });

export const formatPct = (n: number) => `${n.toFixed(n < 10 ? 1 : 0)}%`;

export const formatDate = (iso: string) =>
	new Date(iso).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
	});

export const formatDateTime = (iso: string) =>
	new Date(iso).toLocaleString("en-US", {
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});

export const daysUntil = (iso: string) => {
	const ms = new Date(iso).getTime() - Date.now();
	return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

export const truncateAddress = (addr: string, head = 6, tail = 4) =>
	addr.length <= head + tail + 1 ? addr : `${addr.slice(0, head)}…${addr.slice(-tail)}`;
